__turbopack_context__.v({
  "Icon": "hqXdSG_Icon",
  "Root": "hqXdSG_Root",
  "skeleton-loading": "hqXdSG_skeleton-loading",
});
